import React from 'react'
import { Link } from 'react-router-dom'

import { toPath, RootRoutes } from '../../../modules/router/RootRouter'
import NavBar from '../../views/navbar/NavBar'
import AppNavBarButtonGroup from './AppNavBarButtonGroup'

import appIcon from '../../../images/icon-48.png'
import styled from 'styled-components'

const AppNavBar = () => (
  <NavBar isFixedTop isWidthContained isBottomBorder>
    <div className="navbar-brand">
      <Link className="navbar-item" to={toPath(RootRoutes.home)}>
        <AppImg src={appIcon} alt="Biru Moment" />
      </Link>
    </div>

    <NavBarEnd>
      <AppNavBarButtonGroup />
    </NavBarEnd>
  </NavBar>
)

const AppImg = styled.img`
  width: 48px;
  height: 48px;
  max-height: 48px !important;
`

const NavBarEnd = styled.div.attrs({ className: 'navbar-end' })`
  justify-content: flex-end;
  margin-left: auto;

  @media screen and (min-width: 1088px) {
    margin-right: -1rem;
  }
`

export default AppNavBar



// WEBPACK FOOTER //
// ./src/components/templates/app/AppNavBar.js